import { render, staticRenderFns } from "./ItemDropdown.vue?vue&type=template&id=018b2896&scoped=true"
import script from "./ItemDropdown.vue?vue&type=script&lang=js"
export * from "./ItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./ItemDropdown.vue?vue&type=style&index=0&id=018b2896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b2896",
  null
  
)

export default component.exports